import DonorProfileCardTabs from 'modules/donor/components/DonorProfileCardTabs';
import ProfileSideMenuWrapper from 'modules/navigation/components/ProfileSideMenuWrapper';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

const DonorNotesPage: FC = () => {
  const { t } = useTranslation('donor.donorNotesPage');

  const params = useParams();
  const id = params.id || '';

  return (
    <ProfileSideMenuWrapper title={t('donorNotes')}>
      <DonorProfileCardTabs donorId={id} />
    </ProfileSideMenuWrapper>
  );
};
export default DonorNotesPage;
